import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class HotjarService {
	constructor() {
		window['hj'] =
			window['hj'] ||
			function () {
				(window['hj'].q = window['hj'].q || []).push(arguments); // eslint-disable-line prefer-rest-params
			};
	}

	identifyUser(userId: string, identificationObj: any): void {
		window['hj']('identify', userId, identificationObj);
	}

	setEvent(event) {
		window['hj']('event', event);
	}
}
